import type { FC } from "react";
import type { MatchingResultFilters } from "../../../../hooks/use-matching-results-api";

type MatchingResultsFilterProps = {
  filters: MatchingResultFilters;
  onChange: (filters: MatchingResultFilters) => void;
};

const TRIGGER_TYPE_OPTIONS = [
  { value: "freetext", label: "フリー" },
  { value: "manual", label: "手動" },
  { value: "preset", label: "プリセット" },
  { value: "auto", label: "自動" },
] as const;

const SOURCE_TYPE_OPTIONS = [
  { value: "hr", label: "人材" },
  { value: "matter", label: "案件" },
] as const;

const STATUS_OPTIONS = [
  { value: "new", label: "新規" },
  { value: "viewed", label: "閲覧済" },
  { value: "proposed", label: "提案済" },
  { value: "dismissed", label: "却下" },
] as const;

/**
 * マッチング結果フィルターバー
 * @param {MatchingResultsFilterProps} props コンポーネントProps
 * @return {JSX.Element} MatchingResultsFilter コンポーネント
 */
export const MatchingResultsFilter: FC<MatchingResultsFilterProps> = ({
  filters,
  onChange,
}) => {
  const handleTriggerTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange({
      ...filters,
      triggerTypes: value ? [value] : [],
    });
  };

  const handleSourceTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange({
      ...filters,
      sourceTypes: value ? [value] : [],
    });
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange({
      ...filters,
      statuses: value ? [value] : [],
    });
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <select
        className="select select-bordered select-sm"
        value={filters.triggerTypes[0] || ""}
        onChange={handleTriggerTypeChange}
      >
        <option value="">種別: 全て</option>
        {TRIGGER_TYPE_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <select
        className="select select-bordered select-sm"
        value={filters.sourceTypes[0] || ""}
        onChange={handleSourceTypeChange}
      >
        <option value="">ソース: 全て</option>
        {SOURCE_TYPE_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <select
        className="select select-bordered select-sm"
        value={filters.statuses[0] || ""}
        onChange={handleStatusChange}
      >
        <option value="">ステータス: 全て</option>
        {STATUS_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
